export { AboutThisEventEmbedded } from './AboutThisEventEmbedded';
